module.exports = __webpack_public_path__ + "img/bid.d580b64a.svg";